import { ListItem, ListItemIcon, Tooltip } from '@mui/material';
import ListItemButton from '@mui/material/ListItemButton';
import { makeStyles } from '@mui/styles';

import { useIsOverflowed } from '../../../utils';

import SelectableItemLabel from './SelectableItemLabel';

const useStyles = makeStyles(
  ({ palette, spacing }) => ({
    root: {
      color: 'inherit',
      width: '100%',
      padding: spacing(1),
      borderRadius: 4,
      overflow: 'auto',
      pointerEvents: 'auto',
      '& + $root': {
        marginTop: spacing(1),
      },
      '&:hover': {
        backgroundColor: palette.menu.background.unselected.hover,
        color: palette.text.onMain,
      },
      '&.Mui-selected': {
        backgroundColor: palette.menu.background.selected.enabled,
      },
      '&.Mui-selected:hover': {
        backgroundColor: palette.menu.background.selected.hover,
      },
    },
    leftIcon: {
      minWidth: 'auto',
      marginRight: spacing(2),
      color: 'inherit',
    },
  }),
  { classNamePrefix: 'SelectableItem' }
);

export default function SelectableItem({
  label,
  isSelected = false,
  component = 'li',
  leftIcon = null,
  variant = 'bodySmall',
  labelAdornment = null,
  ...otherProps
}) {
  const classes = useStyles();
  const { isOverflowed, setDomElement } = useIsOverflowed([label, isSelected]);
  const isClickable = Boolean(otherProps.onClick);
  const ListComponent = isClickable ? ListItemButton : ListItem;
  return (
    <Tooltip key={label} title={isOverflowed ? label : ''} enterDelay={500}>
      <ListComponent
        className={classes.root}
        disableGutters
        component={component}
        selected={isSelected}
        {...otherProps}
      >
        {leftIcon && (
          <ListItemIcon data-testid="left-icon" className={classes.leftIcon}>
            {leftIcon}
          </ListItemIcon>
        )}

        <SelectableItemLabel variant={variant} ref={setDomElement} color="inherit">
          {label}
        </SelectableItemLabel>

        {labelAdornment}
      </ListComponent>
    </Tooltip>
  );
}
